export default "__VITE_ASSET__BW2kbYR8__"